const SvgIcon = ({ size='24', color='#fff'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path d="M22 12h-6l-2 3h-4l-2-3H2"></path>
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11"></path>
  </svg>
);

export default SvgIcon;

//const SvgIcon = ({ size='24', color='#fff'}) => (
//  <svg
//    xmlns="http://www.w3.org/2000/svg"
//    width={size}
//    height={size}
//    fill={color}
//    version="1.1"
//    viewBox="0 -960 960 960"
//  >
//    <path
//      strokeWidth="1.333"
//      d="M106.667 0q-44 0-75.334-31.333Q0-62.667 0-106.667v-746.666q0-44 31.333-75.334Q62.667-960 106.667-960h746.666q44 0 75.334 31.333Q960-897.333 960-853.333v746.666q0 44-31.333 75.334Q897.333 0 853.333 0Zm0-106.667h746.666v-160h-160Q653.333-216 598-188t-118 28-118-28-95.333-78.667h-160zm373.333-160q50.667 0 92-29.333t57.333-77.333h224v-480H106.667v480h224q16 48 57.333 77.333t92 29.333m-373.333 160h746.666z"
//    ></path>
//  </svg>
//);
//
//export default SvgIcon;
